<!--
 * @Author: hongye
 * @Date: 2020-10-28 16:54:24
 * @LastEditTime: 2023-02-20 10:56:12
 * @Description: 
-->
<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span class="main-r_top_nav active">{{ $t("apiDoc.在线文档") }}</span>
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom">
      <online-doc :onlineData="onlineData">
        <template #api_addr_info>
          <p class="api_addr_info">{{ $t("onlineDoc.地址") }}</p>
          <p class="api_addr_info">{{ $t("onlineDoc.请求方法") }}<span>POST</span></p>
          <p class="api_addr_info">{{ $t("onlineDoc.数据类型") }}<span>X-WWW-FORM-URLENCODED </span></p>
          <p class="api_addr_info">{{ $t("onlineDoc.响应类型") }}<span>JSON</span></p>
        </template>
      </online-doc>
    </div>
    <!-- 在线文档 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";
export default {
  name: "statusFeedback",

  components: { onlineDoc },
  data() {
    return {
      onlineData: {
        //接口描述
        apiDesc: `${this.$t("onlineDoc.trackDescription_3")}`,

        //参数描述  START
        postDataList: [
          //   请求头参数
          {
            title: "Headers",
            value: [
              { name: "apiAccount", type: "Number", require: "Y", normal: "", describe: `${this.$t("onlineDoc.接入方在平台的api账户标识")}` },
              { name: "digest", type: "String", require: "Y", normal: "", describe: `${this.$t("onlineDoc.签名字符串")}` },
              { name: "timestamp", type: "Number", require: "Y", normal: "", describe: `${this.$t("onlineDoc.时间戳，毫秒")}` },
            ],
          },
          {
            title: `${this.$t("onlineDoc.请求参数")}`,
            value: [
              {
                name: "bizContent",
                type: "String",
                require: "Y",
                normal: `${this.$t("onlineDoc.业务参数")}`,
                describe: `${this.$t("onlineDoc.业务参数模块内json格式的string类型")}`,
              },
            ],
          },
          {
            title: `${this.$t("onlineDoc.业务参数")}`,
            value: [
              { name: "billCode", type: "String(30)", require: "Y", normal: "", describe: `${this.$t("onlineDoc.运单号")}` },
              { name: "txlogisticId", type: "String(60)", require: "N", normal: "", describe: `${this.$t("onlineDoc.客户订单号")}` },
              { name: "details", type: "Array", require: "Y", normal: "", describe: `${this.$t("onlineDoc.快递轨迹详情")}` },
            ],
          },
          {
            title: `${this.$t("onlineDoc.details类型说明")}`,
            value: [
              { name: "scanTime", type: "String", require: "Y", normal: "", describe: `${this.$t("onlineDoc.扫描时间")}` },
              { name: "desc", type: "String", require: "Y", normal: "", describe: `${this.$t("onlineDoc.轨迹描述")}` },
              { name: "scanType", type: "String", require: "Y", normal: "", describe: `${this.$t("onlineDoc.scanType")}` },
              { name: "scanTypeCode", type: "String", require: "N", normal: "", describe: `${this.$t("onlineDoc.scanTypeCode")}` },
              { name: "scanNetworkName", type: "String", require: "N", normal: "", describe: `${this.$t("onlineDoc.扫描网点名称")}` },
              { name: "scanNetworkId", type: "String", require: "N", normal: "", describe: `${this.$t("onlineDoc.扫描网点ID")}` },
              { name: "staffName", type: "String", require: "N", normal: "", describe: `${this.$t("onlineDoc.业务员姓名")}` },
              { name: "staffContact", type: "String", require: "N", normal: "", describe: `${this.$t("onlineDoc.业务员联系方式")}` },
              { name: "scanNetworkContact", type: "String", require: "N", normal: "", describe: `${this.$t("onlineDoc.扫描网点联系方式")}` },
              { name: "scanNetworkProvince", type: "String", require: "N", normal: "", describe: `${this.$t("onlineDoc.扫描网点省份")}` },
              { name: "scanNetworkCity", type: "String", require: "N", normal: "", describe: `${this.$t("onlineDoc.扫描网点城市")}` },
              { name: "scanNetworkArea", type: "String", require: "N", normal: "", describe: `${this.$t("onlineDoc.扫描网点区/县")}` },
              { name: "nextStopName", type: "String", require: "N", normal: "", describe: `${this.$t("onlineDoc.上一站(到件)或下一站名称(发件)")}` },
              { name: "sigPicUrl", type: "String", require: "N", normal: "", describe: `${this.$t("onlineDoc.签收图片（签收扫描时，展示该数据）")}` },
              { name: "electronicSignaturePicUrl", type: "String", require: "N", normal: "", describe: `${this.$t("onlineDoc.电子签名（签收扫描时，展示该数据）")}` },
              {name: "longitude",type: "BigDecimal",require: "N",normal: "",describe: `${this.$t('onlineDoc.经度（在问题件扫描时回传）')}`},
              {name: "latitude",type: "BigDecimal",require: "N",normal: "",describe: `${this.$t('onlineDoc.纬度（在问题件扫描时回传）')}`},
              {name: "otp",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.OTP验证码（签收扫描类型时提供）')}`},
              {name: "problemPicUrl",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.问题件图片（在问题件扫描时提供）')}`},
              {name: "secondLevelTypeCode",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.问题件二级编码')}`},
              {name: "arrivalPicUrl",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.到件图片（到件扫描时，展示该数据，多张图片以逗号分割）')}`}
            ],
          },
        ],
        //参数描述  END
        //报文描述 start
        responseDataList: [
          //   响应参数
          {
            title: `${this.$t("onlineDoc.响应参数")}`,
            value: [
              { name: "code", type: "String", require: "Y", normal: "", describe: `${this.$t("onlineDoc.返回码，见附录")}` },
              { name: "msg", type: "String", require: "Y", normal: "", describe: `${this.$t("onlineDoc.描述")}` },
              { name: "data", type: "String", require: "Y", normal: "", describe: `${this.$t("onlineDoc.业务数据")}` },
            ],
          },
        ],
        //请求示例
        requestCode: `Header：
apiAccount=292508153084379141
digest=5EJcbtDRjOvSj+uGThytpA==
timestamp=1638429847416

Body：
bizContent="{"billCode":"UTE300000056947","details":[{"billCode":"UTE300000056947","desc":"【Riyadh】The Pickup courier [Pinky(+966-08070003)] of [Riyadh station 1] has picked up the parcel ","scanNetworkCity":"Riyadh","scanNetworkId":193,"scanNetworkName":"Riyadh station 1","scanNetworkProvince":"Riyadh","scanNetworkTypeName":"网点","scanTime":"2022-06-06 10:10:28","scanType":"Pickup scan"}]}"`,
        //返回示例
        responseCode: {
          code: "1",
          msg: "success",
          data: {},
        },
        errcodeJson: [],
      },
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>
